import React from 'react';
import { usePopupManager, useShowContextRequired } from 'ui-builder';
import { ConfirmDeletePopup, IconButton, IconType } from 'features/nekst-widgets';
import { ProjectDocument, ProjectDocumentPermission, useProjectDocumentsService } from 'nekst-api';

function DeleteFilePopup(props: {
  data: ProjectDocument,
}) {
  const documentService = useProjectDocumentsService();
  return (
    <ConfirmDeletePopup
      deleteFunc={async () => {
        await documentService.setFile(props.data.id, undefined);
      }}
      message={`Are you sure you want to delete file "${props.data._file.name}"?`}
    />
  );
}

export default function DeleteFileButton() {

  const popupManager = usePopupManager();

  const showContext = useShowContextRequired<ProjectDocument>();

  const document = showContext.data;

  if (document.fileId && document._permissions.includes(ProjectDocumentPermission.SET_FILE)) {
    return (
      <IconButton
        type={IconType.TRASH_CAN}
        onClick={async () => {
          popupManager.openPopup(<DeleteFilePopup data={document} />);
        }}
        title="Delete File"
      />
    );
  } else {
    return null;
  }
}
